/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleManagementListSaleResponse } from './CarpsaleManagementListSaleResponse';

export type CarpsaleManagementListSaleResponseApiRespoonse = {
    data?: CarpsaleManagementListSaleResponse;
    status?: CarpsaleManagementListSaleResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleManagementListSaleResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

